exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-loader .sf-loader__overlay{background-color:transparent}\n", ""]);

// exports
